module.exports = __webpack_public_path__ + "media/images/landing/persons/ludek-motycka-d888044b81e1c87a1a09af1b4e216f42.jpg";